import React, { useState } from 'react';
import FeedbackButton from './FeedbackButton';
import FeedbackModal from './FeedbackModal';
import TimeLimitedPopup from './TimeLimitedPopup';
import Post from '../../services/postService';
import AuthData from '../AuthData';

function Feedback() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showThankYou, setShowThankYou] = useState(false);
    const [submittedType, setSubmittedType] = useState('feedback');

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const handleSubmit = async (feedbackData) => {
        try {
            console.log('Feedback submitted:', feedbackData);
            
            const authData = AuthData.getAuthData();
            const url = `${authData.appFunctionUrl}/api/feedback?code=${authData.azureFunctionKey}`;
            
            // Transform data for backend
            const backendData = {
                type: feedbackData.type,
                subject: feedbackData.subject,
                message: feedbackData.message,
                rating: feedbackData.rating || 0,
                priority: feedbackData.priority || null,
                images: feedbackData.images?.map(img => img.data) || []
            };
            
            // Submit to backend via SubmitFeedbackFunction
            const response = await Post(url, authData.clientId, backendData);
            
            console.log('Feedback submission response:', response);
            
            setSubmittedType(feedbackData.type);
            setIsModalOpen(false);
            setShowThankYou(true);
            
            return { 
                success: true, 
                type: feedbackData.type,
                id: response.data?.id
            };
        } catch (error) {
            console.error('Error submitting feedback:', error);
            throw error;
        }
    };

    const closeThankYou = () => setShowThankYou(false);

    return (
        <>
            <FeedbackButton onClick={openModal} />
            <FeedbackModal 
                isOpen={isModalOpen}
                onClose={closeModal}
                onSubmit={handleSubmit}
            />
            <TimeLimitedPopup 
                isVisible={showThankYou}
                onClose={closeThankYou}
                duration={4000}
                type="success"
                title={submittedType === 'feedback' ? 'Thank You!' : 'Issue Reported!'}
                message={
                    submittedType === 'feedback' 
                        ? 'Your feedback has been successfully submitted.'
                        : 'Your issue report has been successfully submitted.'
                }
                subMessage={
                    submittedType === 'feedback'
                        ? 'We appreciate your input and will review it carefully.'
                        : 'Our team will investigate and get back to you soon.'
                }
            />
        </>
    );
}

export default Feedback;